<template>
  <div class="app-container" v-show="isSuper || allowDashboard">
    <div class="pure-g">
      <div class="pure-u-1-2">
        <div class="pure-g">
          <div class="pure-u-1-3">
            <div class="whiteBox dashboard_number">
              <div class="title">今日线索</div>
              <div class="number">{{ summary.todayClueCount }}</div>
              <div class="desc">
                <span>昨日: {{ summary.yesterdayClueCount }}</span>
                <i :class="getRateIcon(summary.clueRate)">
                  {{ summary.clueRate }}%
                </i>
              </div>
            </div>
          </div>
          <div class="pure-u-1-3">
            <div class="whiteBox dashboard_number">
              <div class="title">待清洗线索</div>
              <div class="number">{{ summary.todayWaitingClearClueCount }}</div>
              <div class="desc">
                <span>昨日: {{ summary.yesterdayWaitingClearClueCount }}</span>
                <i :class="getRateIcon(summary.waitingClearClueRate)">
                  {{ summary.waitingClearClueRate }}%
                </i>
              </div>
            </div>
          </div>
          <div class="pure-u-1-3">
            <div class="whiteBox dashboard_number">
              <div class="title">今日有效线索</div>
              <div class="number">{{ summary.todayValidClueCount }}</div>
              <div class="desc">
                <span>昨日: {{ summary.yesterdayValidClueCount }}</span>
                <i :class="getRateIcon(summary.validClueRate)">
                  {{ summary.validClueRate }}%
                </i>
              </div>
            </div>
          </div>
          <div class="pure-u-1-3" style="margin-top: 15px;">
            <div class="whiteBox dashboard_number">
              <div class="title">今日线下建档</div>
              <div class="number">{{ summary.todayStoreCustomerCount }}</div>
              <div class="desc">
                <span>昨日: {{ summary.yesterdayStoreCustomerCount }}</span>
                <i :class="getRateIcon(summary.storeCustomerRate)">
                  {{ summary.storeCustomerRate }}%
                </i>
              </div>
            </div>
          </div>
          <div class="pure-u-1-3" style="margin-top: 15px;">
            <div class="whiteBox dashboard_number">
              <div class="title">今日清洗率</div>
              <div class="number">{{ summary.todayClearClueRate }}%</div>
              <div class="desc">
                <span>昨日: {{ summary.yesterdayClearClueRate }}%</span>
                <i :class="getRateIcon(summary.clearClueRateRate)">
                  {{ summary.clearClueRateRate }}%
                </i>
              </div>
            </div>
          </div>
          <div class="pure-u-1-3" style="margin-top: 15px;">
            <div class="whiteBox dashboard_number">
              <div class="title">今日有效率</div>
              <div class="number">{{ summary.todayValidClueRate }}%</div>
              <div class="desc">
                <span>昨日: {{ summary.yesterdayValidClueRate }}%</span>
                <i :class="getRateIcon(summary.validClueRateRate)">
                  {{ summary.validClueRateRate }}%
                </i>
              </div>
            </div>
          </div>
          <div class="pure-u-1-3" style="margin-top: 15px;">
            <div class="whiteBox dashboard_number">
              <div class="title">注册经销商</div>
              <div class="number">{{ summary.joinedDealerCount }}</div>
              <div class="desc"></div>
            </div>
          </div>
          <div class="pure-u-1-3" style="margin-top: 15px;">
            <div class="whiteBox dashboard_number">
              <div class="title">激活人员</div>
              <div class="number">{{ summary.activedMemberCount }}</div>
              <div class="desc"></div>
            </div>
          </div>
          <div class="pure-u-1-3" style="margin-top: 15px;">
            <div class="whiteBox dashboard_number">
              <div class="title">未激活人员</div>
              <div class="number">{{ summary.inactivedMemberCount }}</div>
              <div class="desc"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="pure-u-1-2">
        <div class="whiteBox dashboard_topic">
          <div class="portlet-title">
            <div class="pure-g">
              <div class="pure-u-1-2">
                <i class="el-icon-d-arrow-right">&nbsp;</i>
                渠道分布
              </div>
              <div class="pure-u-1-2" style="text-align: right;">
                <span
                  :class="sourceDateType == 4 ? '' : 'click_link'"
                  @click="retrieveSourceData(4)"
                >
                  今日
                </span>
                <span
                  :class="sourceDateType == 3 ? '' : 'click_link'"
                  @click="retrieveSourceData(3)"
                >
                  本周
                </span>
                <span
                  :class="sourceDateType == 2 ? '' : 'click_link'"
                  @click="retrieveSourceData(2)"
                >
                  本月
                </span>
                <span
                  :class="sourceDateType == 1 ? '' : 'click_link'"
                  @click="retrieveSourceData(1)"
                >
                  本年
                </span>
                <span
                  :class="sourceDateType == 0 ? '' : 'click_link'"
                  @click="retrieveSourceData(0)"
                >
                  所有
                </span>
              </div>
            </div>
          </div>
          <div class="portlet-content">
            <div
              id="sourceChart"
              style="height: 350px;"
              v-loading="sourceChartLoading"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="pure-g" style="margin-top: 20px;">
      <div class="pure-u-1-1">
        <div class="whiteBox dashboard_topic">
          <div class="portlet-title">
            <div class="pure-g">
              <div class="pure-u-1-2">
                <i class="el-icon-d-arrow-right">&nbsp;</i>
                线索趋势
              </div>
              <div class="pure-u-1-2" style="text-align: right;"></div>
            </div>
          </div>
          <div class="portlet-content">
            <div
              id="trendChart"
              style="height: 400px;"
              v-loading="trendChartLoading"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.whiteBox {
  background-color: #ffffff;
  box-shadow: rgb(206, 211, 217) 1px 1px 1px 1px;
  padding: 30px;
}

.dashboard_number {
  margin-right: 20px;
  padding: 20px 20px 5px 20px;
  height: 130px;
}

.dashboard_number .title {
  font-size: 14px;
  line-height: 30x;
  height: 30px;
  border-bottom-width: 0px;
  padding-bottom: 5px;
  font-weight: 400;
  color: #606266;
}

.dashboard_number .number {
  font-size: 30px;
  border-bottom-width: 0px;
  line-height: 30px;
  height: 40px;
  color: #303133;
}

.dashboard_number .desc {
  font-size: 12px;
  line-height: 20px;
  height: 20px;
}

.dashboard_number .desc i.el-icon-caret-left {
  color: black;
}

.dashboard_number .desc i.el-icon-caret-top {
  color: red;
}

.dashboard_number .desc i.el-icon-caret-bottom {
  color: green;
}

.dashboard_topic {
  margin-right: 20px;
  padding: 0px;
  height: 100%;
}

.dashboard_topic .portlet-title {
  padding: 8px 10px 2px 10px;
  border-bottom: 1px solid #eee;
  height: 26px;
  font-weight: 500;
  font-size: 12px;
  color: #606266;
}

.dashboard_topic .portlet-content {
  padding: 15px;
}

.click_link {
  color: #5182e4;
  cursor: pointer;
  font-size: 12px;
}

a.click_link {
  text-decoration: none;
}
</style>

<script>
import store from '@/store'
import { Chart } from '@antv/g2'
import Cookies from 'js-cookie'
export default {
  name: 'dashboard',
  data() {
    return {
      isSuper: store.getters.user.isSuper,
      summary: {},
      chartData: [],

      sourceDateType: 4,
      sourceChart: {},
      sourceChartLoading: true,
      sourceDate: [],

      trendChart: {},
      trendChartLoading: true,
      trendDate: [],
      allowDashboard: '',
    }
  },
  created() {
    // let needChangePassword = Cookies.get('ZZ-backend-needChangePassword');
    // if (needChangePassword && needChangePassword != '') {
    //   Cookies.set('ZZ-backend-needChangePassword', '');
    //   this.$router.push({
    //     path: "/profile/changePassword",
    //   });
    // }
  },
  mounted() {
    this.allowDashboard = JSON.parse(
      localStorage.getItem('Admin-User'),
    ).allowDashboard
    if (this.isSuper || this.allowDashboard) {
      setTimeout(() => {
        this.retrieveSummary()
        this.renderSourceChart()
        this.renderTrendChart()
      }, 200)
    }
  },
  methods: {
    getRateIcon(rate) {
      if (rate == 0) {
        return 'el-icon-caret-left'
      }
      if (rate > 0) {
        return 'el-icon-caret-top'
      }
      if (rate < 0) {
        return 'el-icon-caret-bottom'
      }
      return ''
    },
    retrieveSummary() {
      var parent = this
      parent.importSource = []
      this.$httpAuth
        .post('/v1/backendReportRpc/summary', {})
        .then(function (response) {
          console.log(response.data)
          parent.summary = response.data
        })
    },
    renderSourceChart() {
      var chart = new Chart({
        container: 'sourceChart',
        autoFit: true,
        height: 420,
      })
      chart.data(this.chartData)
      chart.tooltip({
        itemTpl: '<li>线索数: {value}</li>',
      })
      chart.coord().transpose()
      chart.interval().position('name*count1')
      chart.render()

      this.sourceChart = chart
      this.retrieveSourceData(4)
    },
    retrieveSourceData(dateType) {
      this.sourceDateType = dateType
      var parent = this
      parent.customerChartLoading = true
      this.$httpAuth
        .post('/v1/backendReportRpc/sourceSummary', {
          dateType: dateType,
        })
        .then(function (response) {
          var data = response.data.data
          data.sort(function (a, b) {
            var comparison = 0
            if (a.count1 > b.count1) {
              comparison = 1
            } else if (a.count1 < b.count1) {
              comparison = -1
            }
            return comparison
          })
          for (const item of data) {
            if (item.name === '垂媒-懂车帝') {
              item.name = ' 垂媒-懂车帝'
              break;
            }
          }
          parent.sourceChart.changeData(data)
          parent.sourceDate = data
          parent.sourceChartLoading = false
        })
        .catch(() => {
          parent.sourceChartLoading = false
        })
    },
    renderTrendChart() {
      var chart = new Chart({
        container: 'trendChart',
        autoFit: true,
        height: 430,
      })
      chart.data(this.chartData)
      chart.tooltip({
        crosshairs: {
          type: 'line',
        },
        shared: true,
      })
      chart.axis('count1', {
        label: {
          formatter: function formatter(val) {
            return val
          },
        },
      })
      chart.line().position('name*count1').color('column1').shape('smooth')
      chart.point().position('name*count1').color('column1').size(4).shape({
        stroke: '#fff',
        lineWidth: 1,
      })
      chart.render()
      this.trendChart = chart
      this.retrieveTrendData()
    },
    retrieveTrendData() {
      this.trendChartLoading = true
      this.$httpAuth
        .post('/v1/backendReportRpc/clueTrend', {})
        .then((response) => {
          this.trendChart.changeData(response.data.data)
          this.trendChartLoading = false
        })
        .catch(() => {
          this.trendChartLoading = false
        })
    },
  },
}
</script>
